import { render, staticRenderFns } from "./WhatWeDoStep.vue?vue&type=template&id=1e67ee7e&"
import script from "./WhatWeDoStep.vue?vue&type=script&lang=ts&"
export * from "./WhatWeDoStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports